import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";
import ImpersonationReducer from "./auth/impersonate/reducer";
import refreshReducer from "./auth/refresh/reducer";
import ContractorReducer from "./auth/contractor/reducer";

import JobReducer from "./jobs/reducer";

//import APIKeyReducer from "./apiKey/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Jobs: JobReducer,
    Impersonate: ImpersonationReducer,
    Refresh: refreshReducer,
    Contractor: ContractorReducer
});

export default rootReducer;